// extracted by mini-css-extract-plugin
export default {"loadingBox":"index_loadingBox_-zNvo","loadingbanner":"index_loadingbanner_4QFbS","flare":"index_flare_PrtZY"};